import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const PastBookingModalPurchaseDate = ({ booking }) => {
  if (booking.onDemand) { return null; }

  return (
    <span className="booking-purchased-on">
      Purchased on {booking.purchasedAt.format('ddd MMM DD, YYYY')}
    </span>
  );
};

PastBookingModalPurchaseDate.propTypes = propTypes;
export default PastBookingModalPurchaseDate;
